import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Blog3Img from "../../utils/images/LeadsQLogo.png"; // keep your existing import path
import SectionSeparator from "../../components/Separator/SectionSeparator";

import "./Footer.css";

const socialLinks = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61555281338509&mibextid=ZbWKwL",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 512 512">
        <path fill="currentColor" d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/leads-q-research/",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 448 512">
        <path fill="currentColor" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/leadsqresearch/profilecard/?igsh=Nm1hMGVkdDdpdzZo",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 448 512">
        <path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
      </svg>
    ),
  },
  {
    label: "X (Twitter)",
    href: "https://x.com/q_leads95617",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 448 512">
        <path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z" />
      </svg>
    ),
  },
];

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Our Services", to: "/courses" },
  { label: "About Us", to: "/about" },
  { label: "Get In Touch", to: "/contact" },
];

const contactInfo = [
  { icon: "📍", text: "Main Address : Nagpur, Maharashtra, India" },
  { icon: "📞", text: "Phone Number : +91 8329025467" },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="none">
        <circle cx="16" cy="16" r="16" fill="#25D366" />
        <path fill="#fff" d="M23.5 8.5A10.44 10.44 0 0 0 16 5.5C10.75 5.5 6.5 9.75 6.5 15a9.43 9.43 0 0 0 1.4 4.97L6.5 26.5l6.7-1.76A9.5 9.5 0 0 0 16 25.5c5.25 0 9.5-4.25 9.5-9.5a9.43 9.43 0 0 0-2-5Zm-7.5 14.6a7.88 7.88 0 0 1-4.02-1.1l-.29-.17-2.98.78.8-2.91-.19-.3A7.9 7.9 0 0 1 8.1 15a7.9 7.9 0 0 1 7.9-7.9 7.9 7.9 0 0 1 7.9 7.9 7.9 7.9 0 0 1-7.9 7.9Zm4.33-5.9c-.24-.12-1.4-.69-1.61-.77-.22-.08-.38-.12-.54.12-.16.24-.62.77-.76.93-.14.16-.28.18-.52.06a6.57 6.57 0 0 1-1.93-1.19 7.24 7.24 0 0 1-1.34-1.66c-.14-.24 0-.37.1-.49.1-.1.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.47-.4-.4-.54-.41h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.12 3.64.58.25 1.03.4 1.38.51.58.18 1.11.16 1.52.1.46-.07 1.4-.57 1.6-1.12.2-.55.2-1.02.14-1.12-.06-.1-.22-.16-.46-.28Z" />
      </svg>
    ),
    text: 'WhatsApp : +91 8329025467',
  },
  { icon: "✉️", text: "Email - christine@leadsqresearch.com" },
];

export default function Footer() {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <footer className={`ft-footer ${visible ? "ft-footer--visible" : ""}`} ref={ref}>
      <SectionSeparator></SectionSeparator>
      {/* ── Top wave divider ── */}
      <div className="ft-wave">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="#0b0c10" />
        </svg>
      </div>

      <Container className="ft-container">
        <Row className="ft-main-row g-5">

          {/* ── Col 1 : Brand + CTA + Social ── */}
          <Col lg={3} md={5} className="ft-col ft-col--brand" style={{ "--i": 0 }}>
            <p className="ft-tagline">Connecting businesses with the right data, every time.</p>

            <Link to="/contact" className="ft-cta-btn">
              Get In Touch
              <span className="ft-cta-btn__arrow">→</span>
            </Link>

            <div className="ft-social">
              {socialLinks.map((s) => (
                <Link
                  key={s.label}
                  to={s.href}
                  target="_blank"
                  className="ft-social__icon"
                  aria-label={s.label}
                  title={s.label}
                >
                  {s.icon}
                  <span className="ft-social__tooltip">{s.label}</span>
                </Link>
              ))}
            </div>
          </Col>

          {/* ── Col 2 : Nav links ── */}
          <Col lg={2} md={3} sm={6} className="ft-col" style={{ "--i": 1 }}>
            <h6 className="ft-col__heading">Navigation</h6>
            <ul className="ft-nav list-unstyled">
              {navLinks.map((n) => (
                <li key={n.to} className="ft-nav__item">
                  <Link to={n.to} className="ft-nav__link">
                    <span className="ft-nav__arrow">›</span>
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* ── Col 3 : Contact info ── */}
          <Col lg={3} md={4} sm={6} className="ft-col" style={{ "--i": 2 }}>
            <h6 className="ft-col__heading">Contact Us</h6>
            <ul className="ft-contact list-unstyled">
              {contactInfo.map((c, i) => (
                <li key={i} className="ft-contact__item">
                  <span className="ft-contact__icon">{c.icon}</span>
                  <span className="ft-contact__text">{c.text}</span>
                </li>
              ))}
            </ul>
          </Col>

          {/* ── Col 4 : Logo ── */}
          <Col lg={2} md={12} className="ft-col ft-col--logo" style={{ "--i": 3 }}>
            <div className="ft-logo-wrap">
              <img
                src={Blog3Img}
                alt="LeadsQResearch"
                className="ft-logo"
              />
              <span className="ft-logo-glow" />
            </div>
          </Col>

        </Row>

        {/* ── Divider ── */}
        <div className="ft-divider">
          <span className="ft-divider__diamond" />
        </div>

        {/* ── Bottom bar ── */}
        <div className="ft-bottom">
          <p className="ft-copyright">
            © {new Date().getFullYear()} LeadsQResearch. All rights reserved.
          </p>
          <p className="ft-made">
            Made with <span className="ft-heart">♥</span> by LeadsQResearch
          </p>
        </div>

      </Container>
    </footer>
  );
}
